import { enrichRowWithBranch } from "../data/branches";
import type { DataRow } from "../types";
import type { DmaSuggestion } from "./dmaInference";

export type DmaReviewDecision = {
  row_id: string;
  job_id: string | null;
  original_dma: string | null;
  suggested_dma: string | null;
  confirmed_dma: string | null;
  confidence: number;
  method: string;
  candidates_json: string;
  status: "confirmed" | "rejected";
  updated_by: string;
  updated_at: string;
};

export function applyDmaReviewDecisions(rows: DataRow[], decisions: DmaReviewDecision[]): DataRow[] {
  const byRow = new Map(decisions.map((decision) => [decision.row_id, decision]));
  return rows.map((source) => {
    const originalDmaCode = source.originalDmaCode !== undefined ? source.originalDmaCode : source.dmaCode;
    const decision = byRow.get(source.__rowId);
    if (!decision) return { ...source, originalDmaCode };
    const row: DataRow = {
      ...source,
      originalDmaCode,
      dmaReviewStatus: decision?.status ?? null,
      dmaSuggestedCode: decision?.suggested_dma ?? null,
      dmaConfidence: decision?.confidence ?? null,
      dmaMethod: decision?.method ?? null,
      dmaConfirmedBy: decision?.updated_by ?? null,
      dmaConfirmedAt: decision?.updated_at ?? null,
      dmaCode: decision?.status === "confirmed" && decision.confirmed_dma ? decision.confirmed_dma : originalDmaCode,
    };
    return enrichRowWithBranch(row);
  });
}

export function applyAutomaticDmaSuggestions(rows: DataRow[], suggestions: DmaSuggestion[], matchedAt?: string): DataRow[] {
  const automatic = new Map(suggestions.filter((suggestion) => suggestion.autoEligible && suggestion.suggestedDma && suggestion.confidence === 1)
    .map((suggestion) => [suggestion.rowId, suggestion]));
  return rows.map((source) => {
    const originalDmaCode = source.originalDmaCode !== undefined ? source.originalDmaCode : source.dmaCode;
    const suggestion = automatic.get(source.__rowId);
    if (originalDmaCode || !suggestion?.suggestedDma || source.dmaReviewStatus === "confirmed" || source.dmaReviewStatus === "rejected") {
      return { ...source, originalDmaCode };
    }
    return enrichRowWithBranch({
      ...source,
      originalDmaCode,
      dmaCode: suggestion.suggestedDma,
      dmaReviewStatus: "auto",
      dmaSuggestedCode: suggestion.suggestedDma,
      dmaConfidence: 1,
      dmaMethod: "road-reference-auto",
      dmaConfirmedBy: "Road_DMA",
      dmaConfirmedAt: matchedAt ?? null,
    });
  });
}

